<template>
    <div class="flex items-center border rounded">
        <div class="grow-0 p-4">
            <img :src="user?.profile_photo_url" class="w-8 h-8 rounded-full" />
        </div>
        <div class="flex-auto">
            <h3 class="text-sm font-bold">{{ user.name }}</h3>
            <p class="text-xs">{{ user.email }}</p>
        </div>
    </div>
</template>

<script setup lang="ts">
import type { User } from '@src/Users/Pages/types';
import { toRef } from 'vue';

interface Props {
    user?: User | null;
}

const props = withDefaults(defineProps<Props>(), {
    user: null,
});

const user = toRef(props, 'user');
</script>
